import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=146e32d3&scoped=true&"
import script from "./SalePage.vue?vue&type=script&lang=ts&"
export * from "./SalePage.vue?vue&type=script&lang=ts&"
import style0 from "./SalePage.vue?vue&type=style&index=0&id=146e32d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e32d3",
  null
  
)

export default component.exports